module.exports = __webpack_public_path__ + "static/step-three@2x-aa4a9b667e8ecefa1b1414e172007ef0.png";